<template>
  <label
    class="flex w-fit items-center gap-3 text-[14px] leading-[22px] font-normal"
    :class="disabled ? 'cursor-not-allowed text-muted' : 'cursor-pointer text-label'"
  >
    <span class="relative flex size-4 shrink-0 items-center justify-center">
      <input
        :id="id"
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        class="peer size-4 cursor-pointer appearance-none rounded-[2px] border border-line-strong bg-white checked:border-blue-bright checked:bg-blue-bright focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-bright disabled:cursor-not-allowed disabled:border-line disabled:bg-surface-muted disabled:checked:border-blue-soft disabled:checked:bg-blue-soft"
        @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
      />
      <CheckboxCheckIcon
        class="pointer-events-none absolute hidden w-2.5 text-white peer-checked:block"
        aria-hidden="true"
      />
    </span>
    <slot />
  </label>
</template>

<script setup lang="ts">
import CheckboxCheckIcon from '@/assets/svg/checkbox-check.svg?component'

defineProps<{
  id: string
  modelValue: boolean
  /** Frozen while the calculation runs: greyed out, the check stays visible. */
  disabled?: boolean
}>()

const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()
</script>
